import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useLetterFormatData } from '@/composables/format-edit/useLetterFormatData'
import LetterExampleSentenceDialog, {
  type LetterExampleSentenceItem
} from '@/components/format-edit/letter/LetterExampleSentenceDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterTextWithExamplesCard',
  props: {
    currentCardId: null,
    cardId: null,
    title: null,
    description: null,
    fieldKey: null,
    errorKey: null,
    dialogName: null,
    sentences: null,
    previewErrors: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  cardId: string
  title: string
  description: string
  fieldKey: 'introSummary' | 'entrySummary'
  errorKey: string
  dialogName: string
  sentences: LetterExampleSentenceItem[]
  previewErrors: Record<string, string | undefined>
};



const formatData = useLetterFormatData()
const dialogVisible = ref(false)

const filteredItems = computed(() => {
  const selectedOccupation = formatData.occupation
  return (props.sentences || []).filter(
    (item) => item.type === selectedOccupation
  )
})

function onSelect(sentences: string) {
  formatData[props.fieldKey] = sentences
}

return { __sfc: true,props, formatData, dialogVisible, filteredItems, onSelect, LetterExampleSentenceDialog }
}

})